<template>
  <AuthLayout tab="login">
    <LoginForm/>
  </AuthLayout>
</template>

<script>
    import LoginForm from "../components/forms/LoginForm.vue";
    import AuthLayout from "@/components/public/AuthLayout.vue";
    import {useHead} from "@vueuse/head";

    export default {
        name: 'LoginView',
        components: {
            LoginForm,
            AuthLayout,
        },
        mounted() {
          useHead({
            title: 'Connexion - Logiciel de facturation électronique et gestion client',
            meta: [
              {
                name: 'robots',
                content: 'noindex, nofollow'
              }
            ]
          });
        }
    }
</script>
